
// ==============================================

//        INTERFACE FUNCTIONS

// ==============================================

document.addEventListener('DOMContentLoaded', function(e) {


  //        Share buttons
  // ==============================================
  $('.btn-share').click(function(e){
    e.preventDefault();

    var type         = $(this).data('type'),
       url           = encodeURIComponent($('meta[property="og:url"]').attr('content')),
       title         = encodeURIComponent($('meta[property="og:title"]').attr('content')),
       description   = encodeURIComponent($('meta[property="og:description"]').attr('content')),
       image         = $('meta[property="og:image"]').attr('content'),
       twitter_title = encodeURIComponent($('meta[name="twitter:title"]').attr('content')),
       hash_tags     = '',
       u             = '';

       // ∆∆∆∆∆ tester ∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆
       // url           = encodeURIComponent('https://biendansmespattes.fr/ouverture-du-salon/');
       // url           = encodeURIComponent('http://pekinunderground.com/backstages/le-village-dartistes-de-zhengyang/');
       // url           = encodeURIComponent('http://newsite.celineclement.com'),
       // twitter_title = encodeURIComponent("le twitter titre");
       // title         = encodeURIComponent("le titre");
       // hash_tags     = encodeURIComponent('serigraphie');
       // ∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆

     switch (type) {
       case 'facebook':
         u = `http://www.facebook.com/sharer/sharer.php?u=${url}`;
         break;

       case 'twitter':
         u   = `https://twitter.com/intent/tweet/?url=${url}&text=${twitter_title}`;
         break;

       case 'pinterest':
         u = `https://www.pinterest.com/pin/create/button/?url=${url}&description=${title}&hashtags=${hash_tags}`;
         break;

       case 'linkedin':
         u = `https://www.linkedin.com/shareArticle?mini=true&url=${url}`;
         break;

       case 'googleplus':
         u = `https://plus.google.com/share?url=${url}`;
         break;

       default:
         console.log('Sorry, we are out of ' + type + '.');
         return;
     }

      centerPopup(u, 600, 450);
    });


    function centerPopup(url, width, height) {
      var screenLeft = window.screenLeft || window.screenX,
          screenTop  = window.screenTop || window.screenY,
          left       = screenLeft + ($(window).width() - width) / 2,
          top        = screenTop + ($(window).height() - height) / 2;
      var params     = `menubar=no,toolbar=no,resizable=yes,width=${width},height=${height},top=${top},left=${left}`;
      window.open(url, '', params);
    }

})
